import axios from "axios";

const baseDomain = process.env.VUE_APP_BASEDOMAIN;
const baseEnv = process.env.VUE_APP_BASEENV;

const baseUrl = `${baseDomain}/${baseEnv}`;

export class Fanbase {
    constructor() { }

    getTemplate(prj, domain) {
        return new Promise((resolve, reject) => {
            const url = `${baseUrl}/surveytemplate/${domain}/${prj}`;
            axios.get(url).then((response) => {
                const obj = JSON.parse(JSON.stringify(response.data))
                resolve(obj);
            }, (error) => {
                reject(error);
            });
        });
    }
    getTemplateByFullDomain(fullDomain) {
        return new Promise((resolve, reject) => {
            const url = `${baseUrl}/surveytemplate2/${fullDomain}`;
            axios.get(url).then((response) => {
                if (response.data.header.codigo === 1) {
                    resolve(JSON.parse(JSON.stringify(response.data)))
                } else {
                    reject(response.data.header.msg)
                }
            }, (error) => {
                reject(error)
            })
        });
    }

    GetData(prj, id) {
        return new Promise((resolve, reject) => {
            const cmd = `${baseUrl}/dataproj/${prj}/${id}`;
            axios.get(cmd).then(
                (r) => {
                    if (r.data.header.codigo == 1) {
                        resolve(r.data.data);
                    } else {
                        reject(r.data.header.msg);
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    GetCountries() {
        return new Promise((resolve, reject) => {
            let url = `${baseUrl}/country`
            axios.get(url).then(
                r => {
                    if (r.data.header.codigo == 1) {
                        resolve(r.data.data)
                    } else {
                        reject(r.data.header.msg)
                    }
                },
                err => {
                    reject('Confirme sua conexão. ' + err.message)
                },
            )
        })
    }
}
